import { NetworkClient, useClassFactory, useNetworkService } from "@pasta/box-v2";

export class DownstreamApi {
  getBaseEndpoint(letterFileId: number) {
    return `letter-file/${letterFileId}/downstream/`;
  }

  protected get network(): NetworkClient {
    return useNetworkService();
  }

  async seeAgain(lfId: number, downstreamId: number) {
    await this.network.post(`${this.getBaseEndpoint(lfId)}${downstreamId}/see-again`);
  }
}

export const [downstreamApiToken, useDownstreamApi] = useClassFactory(DownstreamApi);
